var React = require('react');

function IcCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.26741 6.80681C1.94685 6.49806 1.43952 6.49806 1.11896 6.80681C0.780937 7.13239 0.780937 7.67358 1.11896 7.99916L5.27273 12L14.881 2.74542C15.2191 2.41985 15.2191 1.87866 14.881 1.55308C14.5605 1.24433 14.0532 1.24433 13.7326 1.55308L5.27273 9.70149L2.26741 6.80681Z","fill":"white","stroke":"white"}));
}

IcCheck.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none"};

module.exports = IcCheck;

IcCheck.default = IcCheck;
